<template>
  <li>
    <!-- Ligne principale : affichage du nom, des inputs et du badge -->
    <div class="row" :style="{ background: backgroundColor }">
      <div class="content">
        <!-- Colonne 1 : Nom (indenté selon le niveau) -->
        <div class="name">
          <span
            class="indent"
            :style="{ marginLeft: level * 20 + 'px' }"
            @click="toggle"
            @dblclick="changeType"
            :class="{ bold: isFolder && childNameSuffix == ''  }"
          >
            <span v-if="isFolder && childNameSuffix == '' ">
              <i v-if="open" aria-hidden="true">- </i>
              <i v-else aria-hidden="true">+ </i>
            </span>
           {{ model.name }}{{ childNameSuffix }}
          </span>
        </div>

        <!-- Colonne 2 : Inputs pour les paramètres -->
        <div class="inputs">
          <input
            type="text"
            v-model="model.parameters.performanceRadioFrameThreshold_1"
            :size="2"
            @input="validateInput($event, 'performanceRadioFrameThreshold_1')"
          />
          <input
            type="text"
            v-model="model.parameters.performanceRadioFrameThreshold_5"
            :size="2"
            @input="validateInput($event, 'performanceRadioFrameThreshold_5')"
          />
          <input
            type="text"
            v-model="model.parameters.performanceRadioFrameThreshold_7"
            :size="2"
            @input="validateInput($event, 'performanceRadioFrameThreshold_7')"
          />
          <input
            type="text"
            v-model="model.parameters.performanceRadioFrameThreshold_10"
            :size="2"
            @input="validateInput($event, 'performanceRadioFrameThreshold_10')"
          />
          <input
            type="text"
            v-model="model.parameters.performanceRadioFrameThreshold_30"
            :size="2"
            @input="validateInput($event, 'performanceRadioFrameThreshold_30')"
          />
        </div>

        <!-- Colonne 3 : Badge affichant le scope (clic pour copier) -->
        <div class="badge" @click="copyCode">
          {{ model.scope }}
        </div>
      </div>
    </div>

    <!-- Affichage récursif des enfants si le noeud est un dossier -->
      <ul v-show="open" v-if="isFolder && !(isFinalLevel && hasOnlyOneChild)">
      <json-edit
        v-for="(child, index) in model.children"
        :key="index"
        :model="child"
        :level="level + 1"
        :levelsNumber="levelsNumber"
        @modified="$emit('modified')"
      ></json-edit>
    </ul>
  </li>
</template>

<script>
export default {
  name: "JsonEdit",
  props: {
    model: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
      levelsNumber: {
      type: Number,
      default: 0,
      collapsed: false,
    },
  },
  data() {
    return {
      open: false,
      errors: [],
    };
  },
  computed: {
        isFinalLevel() {
      return this.level === this.levelsNumber;
    },
    hasOnlyOneChild() {
      return this.model.children && this.model.children.length === 1;
    },
    childNameSuffix() {
      if (this.isFinalLevel && this.hasOnlyOneChild) {
        return ` (${this.model.children[0].name})`;
      }
      return "";
    },
    isFolder() {
      return this.model.children && this.model.children.length > 0;
    },
    backgroundColor() {
      // Légère variation de couleur selon le niveau
      const r = 200 + this.level * 11;
      const g = 200 + this.level * 11;
      const b = 255;
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    changeType() {
      if (!this.isFolder) {
        this.open = true;
      }
    },
    copyCode() {
      navigator.clipboard
        .writeText(this.model.scope)
        .then(() => {
          console.log("Code copied to clipboard!");
        })
        .catch((err) => {
          console.error("Error copying text: ", err);
        });
    },
    validateInput(event, field) {
      let value = event.target.value;
      // Supprime tous les caractères non numériques et limite à 2 chiffres
      value = value.replace(/\D/g, "").substring(0, 2);
      event.target.value = value;
      this.model.parameters[field] = value;
      this.errors = this.errors.filter((error) => !error.includes(field));
      // Émettre l'événement pour notifier un changement
      this.$emit("modified");
    },
  },
};
</script>

<style scoped>
.row {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 0;
  border-radius: 4px;
}
.content {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.name,
.inputs,
.badge {
  display: table-cell;
  vertical-align: middle;
  padding: 4px;
}
.name {
  width: 50%;
}
.inputs {
  width: 21%;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: left;
  white-space: nowrap;
  vertical-align: -webkit-baseline-middle;
  background-color: #777;
  border-radius: 10px;
  cursor: pointer;
}
.indent {
  cursor: pointer;
}
.inputs input {
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  margin-right: 4px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: inherit;
  padding: 2px 4px;
}
.inputs input:hover {
  border-color: #333;
}
.inputs input:focus {
  border-color: #333;
  outline: none;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 0;
  list-style-type: none;
}
.errors p {
  margin: 0;
  font-size: 12px;
}
</style>
